var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronDownBigIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.68294 6.84971C2.92701 6.60564 3.32274 6.60564 3.56682 6.84971L9.00015 12.283C9.39774 12.6806 10.052 12.6806 10.4496 12.283L15.8829 6.84971C16.127 6.60564 16.5227 6.60564 16.7668 6.84971C17.0109 7.09379 17.0109 7.48952 16.7668 7.7336L11.3335 13.1669C10.4477 14.0527 9.00201 14.0527 8.11627 13.1669L2.68294 7.7336C2.43886 7.48952 2.43886 7.09379 2.68294 6.84971Z",
    fill: "#101513"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDownBigIcon);
export default __webpack_public_path__ + "static/media/chevron-down-big-icon.6696f828b31ea00eba35e0b80056834b.svg";
export { ForwardRef as ReactComponent };